import { render } from "./ResumePage.vue?vue&type=template&id=390c58c2&scoped=true"
import script from "./ResumePage.vue?vue&type=script&lang=js"
export * from "./ResumePage.vue?vue&type=script&lang=js"

import "./ResumePage.vue?vue&type=style&index=0&id=390c58c2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390c58c2"]])

export default __exports__